import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";

import { createClassNameString } from "@/utils/createClassNameString";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { updateSelectedEvents } from "@/redux/actions/calendar";

const CalendarEventBody = ({ children, className, details, hasBadge, position, testId }) => {
  const dispatch = useDispatch();

  return (
    <div
      className={createClassNameString([
        hasBadge ? "CalendarEvent__body-w-badge" : "CalendarEvent__body",
        className,
      ])}
      onClick={() => {
        dispatch(updateSelectedEvents(details));
      }}
      style={position}
      {...getAutomationDataAttr(testId)}
    >
      {children}
    </div>
  );
};

const UnconfirmedCalendarEventBody = ({ className, position }) => {
  const combinedClassName = createClassNameString([
    "CalendarEvent__body",
    "UnconfirmedCalendarEvent__body",
    className,
  ]);

  return <div className={combinedClassName} style={position} />;
};

const CalendarEventTitle = ({ className, testId, title }) => {
  return (
    <p
      className={createClassNameString(["CalendarEvent__title", className])}
      data-private
      {...getAutomationDataAttr(testId)}
    >
      {title}
    </p>
  );
};

const CalendarEventTime = ({ className, endTime, startTime, strikeTimes }) => {
  let formattedEndTime = endTime.format("h:mm");

  // Moment handled 12 midnight as 11:59
  if (formattedEndTime === "11:59") {
    formattedEndTime = "12:00";
  }

  return (
    <div
      className={createClassNameString([
        "CalendarEvent__time",
        strikeTimes ? "CalendarEvent__time-struck" : undefined,
        className,
      ])}
      data-public
    >
      {/* these are broken up to match responsiveness in the mockup */}
      {/* this is intentionally an en dash */}
      <p className="CalendarEvent__time-item">
        {startTime.format("h:mm")}&thinsp;{startTime.format("A")}
      </p>

      <p className="CalendarEvent__time-item">{" – "}</p>
      <p className="CalendarEvent__time-item">
        {formattedEndTime}&thinsp;{endTime.format("A")}
      </p>
    </div>
  );
};

const CalendarEventBadge = ({ className, text }) => {
  return (
    <div className="CalendarEvent__badge-wrapper">
      <p className={createClassNameString(["CalendarEvent__badge", className])}>{text}</p>
    </div>
  );
};

CalendarEventBody.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]),
  className: PropTypes.string,
  hasBadge: PropTypes.bool,
  position: PropTypes.object,
};

CalendarEventTitle.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
};

CalendarEventTime.propTypes = {
  className: PropTypes.string,
  endTime: PropTypes.instanceOf(moment),
  startTime: PropTypes.instanceOf(moment),
  strikeTimes: PropTypes.bool,
};

CalendarEventBadge.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
};

export {
  CalendarEventBody,
  CalendarEventTime,
  CalendarEventTitle,
  CalendarEventBadge,
  UnconfirmedCalendarEventBody,
};
